import { type ModuleData, ModuleProvider, useModule } from '#providers'
import type { FlowStepData } from '../../pages/LandingPage/flowStepUtils'

interface LandingPageConfig {
	logo?: string
	clientName: string
}

interface LandingPageData {
	flowSteps: FlowStepData[]
}

export type LandingPageModuleData = ModuleData<
	LandingPageData,
	void,
	LandingPageConfig
>

export const LandingPageModuleProvider: typeof ModuleProvider<LandingPageModuleData> =
	ModuleProvider

export const useLandingPageModule: typeof useModule<LandingPageModuleData> =
	useModule
